'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.corporateOnEnterSaga = corporateOnEnterSaga;

var _querystring = require('querystring');

var _effects = require('redux-saga/effects');

var _localStorage = require('redux/saga/helpers/local-storage');

var _corporate = require('constants/corporate');

var _corporate2 = require('helpers/corporate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(corporateOnEnterSaga);

function corporateOnEnterSaga(client, nextState) {
  var corporatePartner, query, corporatePartnerObj;
  return _regenerator2.default.wrap(function corporateOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          corporatePartner = (0, _corporate2.parseCorporatePartnerPath)(nextState.params.corporatePartner);
          query = (0, _querystring.parse)((nextState.location.search || '').substr(1));
          corporatePartnerObj = {
            partner: corporatePartner,
            token: query.token ? query.token : 'unknown',
            initial_url: nextState.location.pathname,
            created: new Date()
          };
          _context.next = 5;
          return (0, _effects.call)(_localStorage.writeLocalStorage, _corporate.CORPORATE_PARTNER_STORAGE_KEY, corporatePartnerObj);

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}